import styled, { css } from 'styled-components';

import { AccordionDetails as MuiAccordionDetails } from '@mui/material';

export const AccordionDetails = styled(MuiAccordionDetails)`
  ${({ theme }) => css`
    padding-top: ${theme.spacing(0)};
  `}
`;
